import { render } from "./ReadMore.vue?vue&type=template&id=9ff29a4a&scoped=true&ts=true"
import script from "./ReadMore.vue?vue&type=script&lang=ts"
export * from "./ReadMore.vue?vue&type=script&lang=ts"

import "./ReadMore.vue?vue&type=style&index=0&id=9ff29a4a&lang=scss&scoped=true"

import exportComponent from "F:\\agent009\\_work\\569\\s\\sites\\easyestate\\easyestate.front\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff29a4a"]])

export default __exports__